import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimelineEventModel } from './timeline-event.model';
import { TimelineEventModelMapper } from './timeline-event.model-mapper';
import { EventStore } from '../../stores/event.store';
import { LoggingService } from '../../../../../modules/src/lib/core/services/logging.service';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  standalone: false,
})
export class TimelineComponent implements OnInit {

  public displayEmptyState: boolean = false;

  public timelineEvents: TimelineEventModel[];

  constructor(
    private readonly translateService: TranslateService,
    private readonly timelineEventModelMapper: TimelineEventModelMapper,
    private readonly eventStore: EventStore,
    private readonly loggingService: LoggingService,
  ) {
  }

  ngOnInit(): void {
    // todo, we need to be binded on the Event store and when we actually don't have any events, and we know for sure,
    // we set displayEmptyState to true.
    this.eventStore.listLatest().subscribe((events) => {
      this.loggingService.debug('Listing events: ' + events);
      this.timelineEvents = events.map((event) => this.timelineEventModelMapper.map(event));
      this.displayEmptyState = this.timelineEvents.length === 0;
    });

  }
}
